
export default {
  name: 'BrandFooter',
  props: {
    attrs: {
      type: Object,
      default() { return {}; },
    },
  },
};
